import React, { useCallback, useEffect, useState } from "react";
import MypageLayout from "./MypageLayout";
import Loader from "./Loader";
import ErrorBar from "./ErrorBar";

// 役割で中身を出し分ける共通ディスパッチャ。
// メニュー名・ルートは一切変えず、/api/employee/me の is_executive によって
// 経営者なら Executive（承認/管理ページ）、社員なら Employee（自分用ページ）を描画する。
const API_URL = process.env.REACT_APP_API_URL || "";

function RoleDispatch({ active, title, Employee, Executive }) {
  const [me, setMe] = useState(null);
  // loading（判定中）/ ready（判定できた）/ error（判定できなかった）の3状態。
  // 「取得に失敗した」と「社員である」を必ず区別する。null に潰して社員側へ
  // フォールバックすると、/me が瞬断しただけで経営者に社員画面が出てしまい、
  // 本人には画面が壊れたようにしか見えない（サイドバーの項目も同時に消える）。
  const [phase, setPhase] = useState("loading");
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const retry = useCallback(() => setReloadKey((k) => k + 1), []);

  useEffect(() => {
    let alive = true;
    setPhase("loading");
    fetch(`${API_URL}/api/employee/me/`, { credentials: "include" })
      .then((r) => {
        if (r.status === 401) throw new Error("ログインが必要です。");
        if (!r.ok) throw new Error("表示する内容の判定に失敗しました。");
        return r.json();
      })
      .then((d) => { if (alive) { setMe(d); setPhase("ready"); } })
      .catch((e) => {
        if (alive) { setError(e.message || "表示する内容の判定に失敗しました。"); setPhase("error"); }
      });
    return () => { alive = false; };
  }, [reloadKey]);

  // 判定中は共通レイアウトのローダーだけ（社員/経営者どちらのページも描かない）。
  if (phase === "loading") {
    return (
      <MypageLayout active={active} title={title}>
        <Loader />
      </MypageLayout>
    );
  }
  if (phase === "error") {
    return (
      <MypageLayout active={active} title={title}>
        <ErrorBar message={error} onClose={() => setError("")} />
        <button className="mp-btn mp-primary" onClick={retry}>再読み込み</button>
      </MypageLayout>
    );
  }
  return me && me.is_executive ? <Executive /> : <Employee />;
}

export default RoleDispatch;
